






















































































































































































import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
// import ModalSpri from "@/components/modal/CardModalSpri.vue";
import CardInputSpri from "@/components/pemeriksaan/resumeSuketV2/CardInputSpri.vue";
import DataSpri from "@/services/DataSpri";
import { storeSoap } from "@/store/modules/soap";
import { storeSpri } from "@/store/modules/spri";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import http from "@/axios/http-common";
import AsesmenMedisIgdStore from "@/store/modules/AsesmenMedisIgdStore";
import SpriSvc from "@/services/SPRI";
import PDFViewer from "@/components/PDFViewer.vue";

@Component({
  components: {
    CardModalTtd,
    CardInputSpri,
    PDFViewer
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardSPRI extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() openModalSpri: boolean;
  @Prop() expandInput!: boolean;
  @Ref() pdfEl: any;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  sess_login = this.stateuser;
  dtSpri: object = {};
  inputSoap = false;
  btnSPRI = false;
  detailSPRI = false;
  ttd = false;
  modalOpenSpri = false;
  modalOpen = false;
  soap: object = {};
  spri: object = {};
  dpjp: object = {};
  // dpjp = 0;
  btnEdit = false;
  btnCetak = false;
  btnTtd = false;
  dataSoap: object = {};
  pageTab = "tab-soap";
  mounted() {
    console.log("openModalSpri", this.openModalSpri);

    if (this.openModalSpri == true) {
      this.inputSpri();
    }
    // this.modalOpenSpri = this.openModalSpri;
    // this.setDataInputSpri();
    this.getSpri();

    this.btnSPRI = true;
    this.inputSoap = true;
    this.detailSPRI = true;
    this.ttd = true;
    // this.soap = this.statesoapdetail[0];
    // console.log("soap spri ", this.statesoapdetail);
    this.stateSpriByReg();

    if (this.stateuser.unit_id == "01" && !this.asesmenMedisIgd) {
      this.getAsesmenMedisIgdData();
    }
  }

  get stateuser() {
    return userModule.user;
  }
  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  get statespri() {
    return storeSpri.spri;
  }
  get statespridetail() {
    return storeSpri.detailspri;
  }
  get canEdit() {
    if (this.readOnly) return false;
    return (
      this.stateuser.profesi == "Dokter" &&
      this.statespridetail &&
      this.statespri.length != 0 &&
      // this.statespridetail.signed == 0 &&
      this.stateuser.id == this.statespridetail.dokter.id
    );
  }

  get canSign() {
    if (this.readOnly) return false;
    return (
      this.stateuser.profesi == "Dokter" &&
      this.statespridetail &&
      this.statespri.length != 0 &&
      this.statespridetail.signed == 0 &&
      this.stateuser.id == this.statespridetail.dokter.id
    );
  }

  get canMakeSuket() {
    if (this.readOnly) return false;
    if (this.stateuser.unit_id != "01" && this.stateuser.unit_id < "30") {
      return (
        this.statesoapdetail.length > 0 && this.stateuser.profesi == "Dokter"
      );
    } else {
      return this.stateuser.profesi == "Dokter";
    }
  }

  get pdfUrl() {
    return this.statespridetail
      ? http.getAPI() + `/spri/${this.statespridetail.id}/pdf`
      : null;
  }

  stateSpriByReg() {
    storeSpri.act_spri_on_reg(this.register);
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }
  @Watch("dataSoap")
  changeSOAP(value) {
    // this.dataSoap=value
    this.getSpri();
  }
  @Watch("dtSpri")
  cekSpri(v) {
    this.dtSpri = v;
  }
  @Watch("expandInput")
  async changeExpandInput(v) {
    if (v) {
      if (this.stateuser.unit_id == "01" && !this.asesmenMedisIgd) {
        await this.getAsesmenMedisIgdData();
      }
    }
  }

  get asesmenMedisIgd() {
    return AsesmenMedisIgdStore.asesmen;
  }

  getAsesmenMedisIgdData() {
    AsesmenMedisIgdStore.getByRegister(this.register);
  }

  respSpri(v) {
    // this.spri = v;
    this.getSpri();
  }
  modalTtd() {
    this.modalOpen = true;
  }
  inputSpri() {
    // this.expandInput = !this.expandInput;
    this.expandInput = true;
    // this.modalOpenSpri = true;
    this.setDataInputSpri();
  }

  setDataInputSpri() {
    // console.log("set data input spri", this.statesoapdetail);

    this.soap = {
      keluhan_utama: "",
      pemeriksaan_penunjang: "",
      s: this.statesoapdetail[0]["s"],
      o: this.statesoapdetail[0]["o"],
      a: this.statesoapdetail[0]["a"],
      p: this.statesoapdetail[0]["p"]
    };

    this.dpjp = {
      id: this.sess_login["id"],
      nama: this.sess_login["nama"]
    };
    // console.log("inpt spri", this.soap);
  }
  editSpri() {
    // console.log("edt spri", this.statespridetail);
    // this.modalOpenSpri = true;
    this.expandInput = true;
    this.soap = {
      keluhan_utama: this.statespridetail["keluhan_utama"],
      pemeriksaan_penunjang: this.statespridetail["pemeriksaan_penunjang"],
      s: this.statespridetail["riwayat_penyakit"],
      o: this.statespridetail["pemeriksaan_fisik"],
      a: this.statespridetail["diagnosis"],
      p: this.statespridetail["terapi"],
      tanggal: this.statespridetail["tanggal"]
    };
    this.dpjp = {
      id: this.statespridetail["dokter"]["id"],
      nama: this.statespridetail["dokter"]["nama"]
    };
  }

  deleteSpri() {
    const q = this.confirmDelete();

    if (q) {
      appModule.setLoading(true);

      SpriSvc.destroy(this.statespridetail.id)
        .then(dt => {
          if (dt.status == 1) {
            appModule.NoticeDelay(dt.message);

            storeSpri.act_spri_on_reg(this.register);
          }
        })
        .finally(() => {
          appModule.setLoading(false);
        });
    }
  }

  confirmDelete() {
    const q = confirm("Menghapus data SPRI ini?");

    return q;
  }

  getSpri() {
    appModule.setLoading(true);
    const dt = DataSpri.getDataSpri(this.register);
    dt.then(dt => {
      appModule.setLoading(false);
      // console.log("ds", dt);
      this.dtSpri = dt;
    });
  }
  passTtd(value) {
    // this.getSpri();
    appModule.setLoading(true);
    const dt = DataSpri.saveDataTtdSpri(
      this.dtSpri["data"][0]["id"],
      this.dtSpri["data"][0]["dokter"]["id"],
      value
    );
    dt.then(dt => {
      appModule.setLoading(false);
      if (dt["data"]["status"] != 1) {
        // ErrorAlert.msgTtd = dt["data"]["message"];
        appModule.addMsgTtd(dt["data"]["message"]);
        this.modalOpen = true;
        // appModule.sendErrorAlert(dt["err"]);
      } else {
        appModule.NoticeDelay("Berhasil Tanda Tangan SPRI");
        this.modalOpen = false;
        // console.log("sukses ttd")
        // this.getSpri();
        this.modalOpen = false;
        appModule.NoticeDelay("Berhasil Tanda Tangan SPRI");
        this.stateSpriByReg();
        appModule.addMsgTtd("");
        // this.btnEdit = false;
        // this.btnTtd = false;
        // this.btnCetak = true;
      }
    });
  }
  cetakSpri() {
    // const routeData =
    //   http.getAPI() + "/spri/" + this.dtSpri["data"][0]["id"] + "/pdf";
    // window.open(routeData, "_blank");
    this.pdfEl.print();
  }
  getHumanDateTime(date) {
    return date
      ? moment(date, "YYYY-MM-DD HH:mm:ss").format("DD MMMM YYYY HH:mm")
      : "";
  }
  closeExpand(v) {
    this.expandInput = v;
  }
}
